// components/layouts/PartnerLayout.js
import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

const PartnerLayout = ({ children }) => {
  return (
    <Layout className="min-h-screen">
      <Content className="bg-gray-100">
        {children}
      </Content>
    </Layout>
  );
};

export default PartnerLayout;